import React from 'react';
import type { NavGroup } from '../../../config/navigation';
import { NavGroupItem } from './NavGroupItem';

interface DesktopNavProps {
  groups: NavGroup[];
}

const DesktopNav: React.FC<DesktopNavProps> = ({ groups }) => {
  return (
    <nav className="hidden lg:flex items-center space-x-1">
      {groups.map((group) => (
        <NavGroupItem key={group.id} group={group} />
      ))}
    </nav>
  );
};

export { DesktopNav };
